import React from 'react';
import { useSearchParams } from 'react-router-dom';
import SandboxPage from './sandbox/SandboxPage';
import ObjectViewerPage from './object-viewer/ObjectViewerPage';

const MODES = [
  { key: 'sandbox', label: 'Sandbox' },
  { key: 'production', label: 'Production' },
];

function DataExplorerPage({
  organization, connectionData, fetchConnectionData, openApiSpec,
}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeMode = searchParams.get('mode') === 'production'
    ? 'production' : 'sandbox';

  const handleModeChange = (mode) => {
    setSearchParams(mode === 'sandbox' ? {} : { mode }, { replace: true });
  };

  return (
    <div className="page-container">
      <div className="flex items-center justify-between">
        <div className="flex items-baseline gap-3">
          <h1 className="page-title">Data Explorer</h1>
          <span className="page-subtitle">
            Browse and inspect API data
          </span>
        </div>
        <div>
          <div className="flex items-center gap-0.5 border border-surface-200 rounded-lg p-0.5 bg-surface-50">
            {MODES.map((m) => (
              <button
                key={m.key}
                type="button"
                onClick={() => handleModeChange(m.key)}
                className={`px-3 py-1.5 text-xs font-medium rounded-md transition-colors ${
                  activeMode === m.key
                    ? 'bg-surface-900 text-white shadow-xs'
                    : 'text-surface-400 hover:text-surface-600'
                }`}
              >
                {m.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {activeMode === 'sandbox' ? (
        <SandboxPage
          organization={organization}
          connectionData={connectionData}
          fetchConnectionData={fetchConnectionData}
        />
      ) : (
        <ObjectViewerPage connectionData={connectionData} openApiSpec={openApiSpec} />
      )}
    </div>
  );
}

export default DataExplorerPage;
